import { useContext, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { CalendarIcon, Container } from './styles'
import DateContext from '../../hooks/date'
import { max, format } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'

const mostRecentDate = (date1: Date, date2: Date): Date => {
  return max([date1, date2])
}
interface CalendarDashboardProps {
  onCalendarClose?: any
  className?: string
  maxDate?: Date
}

export default function CalendarDashboard({
  onCalendarClose,
  className,
  maxDate,
}: CalendarDashboardProps) {
  const [startDate, setStartDate] = useState<any>()
  const [endDate, setEndDate] = useState<any>()

  const { setStateDate } = useContext(DateContext)

  const handleChange = (range: any) => {
    const [startDate, endDate] = range

    setStartDate(startDate)
    setEndDate(endDate)

    if (startDate && endDate) {
      const latestDate = mostRecentDate(new Date(startDate), new Date(endDate))
      const latest = format(latestDate, 'yyyy-MM-dd')

      const dateA = format(startDate, 'yyyy-MM-dd')
      const dateB = format(endDate, 'yyyy-MM-dd')

      if (latest === dateA) {
        setStateDate({
          startDate: dateA,
          endDate: dateB,
          isDateDefault: false,
        })
      } else {
        setStateDate({
          startDate: dateB,
          endDate: dateA,
          isDateDefault: false,
        })
      }
    }
  }

  return (
    <Container className={className}>
      <CalendarIcon
        selected={startDate}
        onChange={handleChange}
        startDate={startDate}
        endDate={endDate}
        locale={pt}
        selectsRange
        onCalendarClose={onCalendarClose}
        dateFormat="dd/MM/yyyy"
        maxDate={maxDate}
      />
    </Container>
  )
}
